<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-table-tennis</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.activities') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 15px 0 15px;" />
      <span style="color:rgba(0, 0, 0, 0.54);">{{$t('activity.show')}}</span>
      <v-select
        single-line
        v-if="typesActivity"
        v-model="content.TypeActivity"
        :items="typesActivity"
        item-text="Name"
        item-value="ID"
        style="margin: 10px 0 0 15px;"
        @change="handleChangeIsModified"
      />
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs4 text-right style="padding-right: 20px">
        {{ $t('acttiv.primaryColor') }}:
      </v-flex>
      <v-flex xs8>
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActivityPrimaryColor"
          :onChangeColor="handleChangePrimaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.secundaryColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActivitySecundaryColor"
          :onChangeColor="handleChangeSecundaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.titleColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActivityColor"
          :onChangeColor="handleChangeTitleColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.descriptionColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ActivityDescriptionColor"
          :onChangeColor="handleChangeDescriptionColor"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/services/api'
  import CustomColorPicker from '@/components/CustomColorPickerV2'
  export default {
    components: {
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      DviewLink: null,
      typesActivity: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLink = response.DviewLink
          this.handleGetTypeActivities()
        })
      },
      handleChangePrimaryColor (color) {
        this.content.ActivityPrimaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeSecundaryColor (color) {
        this.content.ActivitySecundaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeTitleColor (color) {
        this.content.ActivityColor = color
        this.handleChangeIsModified()
      },
      handleChangeDescriptionColor (color) {
        this.content.ActivityDescriptionColor = color
        this.handleChangeIsModified()
      },
      handleGetTypeActivities () {
        this.data = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.DviewLink}/dtouch-type-activity`)
          .then(response => {
            let ta1 = response.data[0].TypeActivity01 && response.data[0].TypeActivity01.length > 0 ? response.data[0].TypeActivity01 : 'Type 01'
            if (ta1.split('#').length === 4) ta1 = ta1.split('#')[0]
            let ta2 = response.data[0].TypeActivity02 && response.data[0].TypeActivity02.length > 0 ? response.data[0].TypeActivity02 : 'Type 02'
            if (ta2.split('#').length === 4) ta2 = ta2.split('#')[0]
            let ta3 = response.data[0].TypeActivity03 && response.data[0].TypeActivity03.length > 0 ? response.data[0].TypeActivity03 : 'Type 03'
            if (ta3.split('#').length === 4) ta3 = ta3.split('#')[0]
            let ta4 = response.data[0].TypeActivity04 && response.data[0].TypeActivity04.length > 0 ? response.data[0].TypeActivity04 : 'Type 04'            
            if (ta4.split('#').length === 4) ta4 = ta4.split('#')[0]
            let ta5 = response.data[0].TypeActivity05 && response.data[0].TypeActivity05.length > 0 ? response.data[0].TypeActivity05 : 'Type 05'            
            if (ta5.split('#').length === 4) ta5 = ta5.split('#')[0]

            this.typesActivity = [
              {
                ID: 0,
                Name: 'TODOS'
              },
              {
                ID: 1,
                Name: ta1
              },
              {
                ID: 2,
                Name: ta2
              },
              {
                ID: 3,
                Name: ta3
              },
              {
                ID: 4,
                Name: ta4
              },
              {
                ID: 5,
                Name: ta5
              }
            ]
          })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

